var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotationWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3800_7184)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M19.7031 5.02734C19.7031 3.90554 20.6126 2.99609 21.7344 2.99609H18.6875C17.5657 2.99609 16.6562 3.90554 16.6562 5.02734C16.6562 6.14915 17.5657 7.05859 18.6875 7.05859H21.7344C20.6126 7.05859 19.7031 6.14915 19.7031 5.02734ZM4.0625 12.9982C4.0625 11.8764 4.97194 10.9669 6.09375 10.9669H3.04688C1.92507 10.9669 1.01562 11.8764 1.01562 12.9982C1.01562 14.12 1.92507 15.0294 3.04688 15.0294H6.09375C4.97194 15.0294 4.0625 14.12 4.0625 12.9982ZM4.0625 20.9021C4.0625 19.7803 4.97194 18.8709 6.09375 18.8709H3.04688C1.92507 18.8709 1.01562 19.7803 1.01562 20.9021C1.01562 22.0239 1.92507 22.9334 3.04688 22.9334H6.09375C4.97194 22.9334 4.0625 22.024 4.0625 20.9021Z",
    fill: "url(#paint0_linear_3800_7184)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.01562 4.0625V6.09375C1.01562 7.21556 1.92507 8.125 3.04688 8.125C4.16868 8.125 5.07812 7.21556 5.07812 6.09375C5.07812 4.97194 4.16868 4.0625 3.04688 4.0625H1.01562ZM1.01562 4.0625V3.04688C1.01562 1.92507 1.92507 1.01562 3.04688 1.01562M9.14062 4.0625V6.09375C9.14062 7.21556 10.0501 8.125 11.1719 8.125C12.2937 8.125 13.2031 7.21556 13.2031 6.09375C13.2031 4.97194 12.2937 4.0625 11.1719 4.0625H9.14062ZM9.14062 4.0625V3.04688C9.14062 1.92507 10.0501 1.01562 11.1719 1.01562M24.9844 21.9375V19.9062C24.9844 18.7844 24.0749 17.875 22.9531 17.875C21.8313 17.875 20.9219 18.7844 20.9219 19.9062C20.9219 21.0281 21.8313 21.9375 22.9531 21.9375H24.9844ZM24.9844 21.9375V22.9531C24.9844 24.0749 24.0749 24.9844 22.9531 24.9844M16.8594 21.9375V19.9062C16.8594 18.7844 15.9499 17.875 14.8281 17.875C13.7063 17.875 12.7969 18.7844 12.7969 19.9062C12.7969 21.0281 13.7063 21.9375 14.8281 21.9375H16.8594ZM16.8594 21.9375V22.9531C16.8594 24.0749 15.9499 24.9844 14.8281 24.9844",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9531 7.10938H19.0938C17.9719 7.10938 17.0625 6.19993 17.0625 5.07812C17.0625 3.95632 17.9719 3.04688 19.0938 3.04688H22.9531C24.0749 3.04688 24.9844 3.95632 24.9844 5.07812C24.9844 6.19993 24.0749 7.10938 22.9531 7.10938ZM6.90625 22.9531H3.04688C1.92507 22.9531 1.01562 22.0437 1.01562 20.9219C1.01562 19.8001 1.92507 18.8906 3.04688 18.8906H6.90625C8.02806 18.8906 8.9375 19.8001 8.9375 20.9219C8.9375 22.0437 8.02806 22.9531 6.90625 22.9531ZM22.9531 15.0312H3.04688C1.92507 15.0312 1.01562 14.1218 1.01562 13C1.01562 11.8782 1.92507 10.9688 3.04688 10.9688H22.9531C24.0749 10.9688 24.9844 11.8782 24.9844 13C24.9844 14.1218 24.0749 15.0312 22.9531 15.0312Z",
    stroke: "url(#paint1_linear_3800_7184)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3800_7184",
    x1: 1.01562,
    y1: 2.99609,
    x2: 17.1775,
    y2: 26.1185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3800_7184",
    x1: 1.44445,
    y1: 0.808606,
    x2: 24.3414,
    y2: 26.6605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3800_7184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationWhite);
export default __webpack_public_path__ + "static/media/quotationWhite.2f1277efb809ee98c27a87c0d935174c.svg";
export { ForwardRef as ReactComponent };